import React, {useEffect, useState} from "react";
import "../../sass/main.scss";
import CmnCard from "../CmnCard";

import caretLeftFill from "../../images/caret-left-fill.svg";
import caretRightFill from "../../images/caret-right-fill.svg";
import $ from "jquery";
import axios2 from "../../helpers/APIHelper";
import Paging from "../common/Paging";
import Fn from "../../libraries/Fn";
import ChkAuthNum from "../common/ChkAuthNum";
import {useHistory} from "react-router-dom";
import SmsNew from "../common/SmsNew";
import Constants from "../../constants/constants";

const EmployeeList = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const history = useHistory();

  const [renew, setRenew] = useState(0);
  const [rets, setRets] = useState([]);
  const [pageInfo, setPageInfo] = useState({});
  const [currPage, setCurrPage] = useState(1);
  const [srchRenew, setSrchRenew] = useState(0);
  const [smsModalOpen, setSmsModalOpen] = useState(false);

  useEffect(() => {
    $('.fn_search_box').each(function () {
      $(this).find("input[type=text]").each(function () {
        $(this).onEnter(() => setSrchRenew(Fn.getRenewTime));
      });
    });
  }, []);

  useEffect(() => {
    if (!srchRenew) return;
    load(1);
  }, [srchRenew]);

  useEffect(() => {
    load();
  }, [currPage, renew]);

  const load = (_page) => {
    axios2
      .post(`/employee/emp/list/ready?s_position=${$('#s_position option:selected').val() || ''}&s_pay_part=${$('#s_pay_part option:selected').val() || ''}&s_part=${$('#s_part option:selected').val() || ''}&s_new_position=${$('#s_new_position option:selected').val() || ''}&s_inout_state=${$('#s_inout_state option:selected').val() || ''}&key=${$('#key').val()}&page=${_page || currPage}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          Fn.processPhone(result?.result, pageInfo, "ret?.hp");

          if ($('#s_position').html() === '') {
            let optionsHTML = '<option value="">::계약명칭::</option>';
            result?.list1?.forEach((list_row) => {
              optionsHTML += `<option value="${list_row.sub_code}">${list_row.sub_code_name}</option>`;
            });
            $('#s_position').html(optionsHTML);
          }
          if ($('#s_part').html() === '') {
            let optionsHTML = '<option value="">::부서구분::</option>';
            result?.list2?.forEach((list_row) => {
              optionsHTML += `<option value="${list_row.sub_code}">${list_row.sub_code_name}</option>`;
            });
            $('#s_part').html(optionsHTML);
          }
          if ($('#s_new_position').html() === '') {
            let optionsHTML = '<option value="">::계약형태::</option>';
            result?.list3?.forEach((list_row) => {
              optionsHTML += `<option value="${list_row.sub_code}">${list_row.sub_code_name}</option>`;
            });
            $('#s_new_position').html(optionsHTML);
          }

          setRets(result?.result);
          setPageInfo(pageInfo);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  //  2-1.
  const form1 = document.getElementById('form1');

  function del_step(seq) {
    let con = $('[id^=achk]:checked').map(function () {
      return $(this).val();
    }).get().join("|");

    if (con === '' || con.split(",").length === 0) {
      window.alert('체크된 리스트가 없습니다.');
      return;
    }

    if (window.confirm('체크한 스텝을 삭제하시겠습니까?')) {
      const formData = new FormData();

      let values = $('[id^=achk]:checked').map(function () {
        return $(this).val();
      }).get().join(",");

      formData.append("chk[]", values);
      formData.append("auth_code", $('#auth_code').val());

      axios2.postFormEx('/employee/emp/del', formData)
        .then((response) => response.json())
        .then(({code, message: data, result, pageInfo}) => {
          data = data.trim();
          if (data === "err") {
            alert('오류가 발생하였습니다');
          } else if (data === "del_ok") {
            alert("삭제되었습니다");
            setRenew(Fn.getRenewTime());
          }
        })
        .catch((error) => {
          console.log(error);
          if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
        });
    }
  }

  //  4-1.
  const popUp = (file, names, width, height, sc) => {
    const w = width;
    const h = height;
    const winl = (window.screen.width - w) / 2;
    const wint = (window.screen.height - h) / 2;
    window.open(file, names, `width=${w}, height=${h}, scrollbars=${sc}, top=${wint}, left=${winl}`);
  };

  function chk_send() {
    var con = 0;
    var editMsgid = "";
    for (let i = 0; i < form1.elements.length; i++) {
      if (form1.elements[i].type == 'checkbox') {
        if (form1.elements[i].checked == true) {
          var nn = form1.elements[i].name;
          var m_chk = nn.substr(0, 3);
          if (m_chk == "chk") {
            con++;
            editMsgid = editMsgid + form1.elements[i].value + "|";
          }
        }
      }
    }
    if (con == 0) {
      window.alert("체크된 리스트가 없습니다.");
      return;
    }

    popUp('../message/sms.html?b_type=manager&s_type=sel&editMsgid=' + editMsgid, 'sms.html', '800', '450', 'no');
  }

  //  5-1.
  function search_send() {
    if (window.confirm("검색된 전체스텝에게 SMS를 발송하시겠습니까?")) {
      popUp('../message/sms.html?b_type=manager&s_type=all&my_sort=seq desc&s_branch_code=central&s_position=&s_pay_part=&key=&s_part=&s_new_position=&s_inout_state=', 'sms.html', '800', '450', 'no');
    }
  }

  function Excel_all_step() {
    var auth_code = $("#auth_code").val();
    if (!auth_code) {
      alert("인증코드를 입력해주세요");
      return;
    }

    var down_reason = $("#down_reason").val();
    if (!down_reason) {
      alert("사유를 입력해주세요");
      return;
    }

    const url = `/xls/employee/all/step?auth_code=${auth_code}&down_reason=${down_reason}`;
    Fn.download(Constants.API_URL + url);
  }

  return (
    <CmnCard onLogout={props.onLogout}>
      <div className="overflowX">
        <div className="d-flex m-3 table_wide_sh2 fn_search_box">
          <div className="pr-1">
            <select className="form-select sel_lg" aria-label="Default select example" id="s_position">
            </select>
          </div>
          <div className="pr-1">
            <select className="form-select sel_lg" aria-label="Default select example" id="s_pay_part">
              <option value="">::수수료부서선택</option>
              <option value="A">본사</option>
              <option value="B">퍼블릭</option>
              <option value="C">PT</option>
              <option value="D">퍼블릭+PT</option>
              <option value="E">GX</option>
              <option value="F">용역</option>
            </select>
          </div>
          <div className="pr-1">
            <select className="form-select sel_lg" aria-label="Default select example" id="s_part">
            </select>
          </div>
          <div className="pr-1">
            <select className="form-select sel_lg" aria-label="Default select example" id="s_new_position">
            </select>
          </div>
          <div className="pr-1">
            <select className="form-select" aria-label="Default select example" id="s_inout_state">
              <option value="">::상태::</option>
              <option value="Y">근무</option>
              <option value="N">퇴사</option>
            </select>
          </div>
          <div className="pr-1">
            <input type="text" className="form-control" aria-describedby="button-addon2" placeholder="이름/핸드폰 검색" id="key"/>
          </div>
          <div className="pr-1">
            <button type="button" className="btn btn-sm btn-point px-3" onClick={() => setSrchRenew(Fn.getRenewTime())}>검색</button>
          </div>
        </div>

        <div className="m-3 pb-2 table_list">
          <table className="view-rounded sub_table_border table_wide">
            <colgroup>
              <col width="60px"/>
              <col width="60px"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="*"/>
              <col width="80px"/>
              <col width="80px"/>
              <col width="80px"/>
              <col width="80px"/>
              <col width="80px"/>
            </colgroup>

            <tr>
              <th>No</th>
              <th>
                <input type="checkbox" onClick={(e) => {
                  if ($(e.target).prop("checked")) $('[id^=achk]').prop("checked", true);
                  else $('[id^=achk]').prop("checked", false);
                }}/>
              </th>
              <th>성명</th>
              <th>계약명칭</th>
              <th>수수료부서</th>
              <th>부서</th>
              <th>계약형태</th>
              <th>PT여부</th>
              <th>기본급</th>
              <th>영업지원금(PT)</th>
              <th>시급</th>
              <th>연락처</th>
              <th>계약체결일</th>
              <th>그룹웨어ID</th>
              <th>상태</th>
              <th>계약서</th>
              <th>서약서</th>
              <th>통장</th>
              <th>등본</th>
            </tr>

            {rets.map((ret, i) => {
              const count = i + 1;
              const seq = ret?.seq;
              const user_name = ret?.user_name;
              const pay_part = ret?.pay_part;
              const pt_YN = ret?.pt_YN;
              const pu_basic_price = ret?.pu_basic_price;
              const pu_hour_price = ret?.pu_hour_price;
              const pt_basic_price = ret?.pt_basic_price;
              const pt_hour_price = ret?.pt_hour_price;
              const hp = ret?.hp;
              const in_date = ret?.in_date;
              const branch_code_name = ret?.branch_code_name;
              const position_name = ret?.position_name;
              const inout_state = ret?.inout_state;
              const groupware_id = ret?.groupware_id;
              const permit_YN = ret?.permit_YN;
              const part_name = ret?.part_name;
              const new_position_name = ret?.new_position_name;
              const contfile_name = ret?.contfile_name;
              const infofile_name = ret?.infofile_name;
              const accountfile_name = ret?.accountfile_name;
              const juminfile_name = ret?.juminfile_name;

              const contfile_name_show = contfile_name ? "Y" : "N";
              const infofile_name_show = infofile_name ? "Y" : "N";
              const accountfile_name_show = accountfile_name ? "Y" : "N";
              const juminfile_name_show = juminfile_name ? "Y" : "N";

              let pay_part_txt;
              if (pay_part === "A") {
                pay_part_txt = "본사";
              } else if (pay_part === "B") {
                pay_part_txt = "퍼블릭";
              } else if (pay_part === "C") {
                pay_part_txt = "PT";
              } else if (pay_part === "D") {
                pay_part_txt = "퍼블릭+PT";
              } else if (pay_part === "E") {
                pay_part_txt = "GX";
              } else if (pay_part === "F") {
                pay_part_txt = "용역";
              } else {
                pay_part_txt = "";
              }

              let pt_YN_txt;
              if (pt_YN === "Y") {
                pt_YN_txt = <font color="red"><strong>Y</strong></font>;
              } else if (pt_YN === "N") {
                pt_YN_txt = "N";
              } else {
                pt_YN_txt = "";
              }

              let inout_state_txt;
              if (inout_state === "Y") {
                inout_state_txt = "근무";
              } else {
                inout_state_txt = <font color="red">퇴사</font>;
              }

              let groupware_id_show;
              if (permit_YN === "Y") {
                groupware_id_show = groupware_id;
              } else {
                groupware_id_show = <font color="red">{groupware_id}</font>;
              }

              const base_seq = btoa(seq);

              const mb_hp = hp;
              const mb_hp_show = Fn.hpShow(mb_hp, pageInfo.totalArticles);

              const base_hp = btoa(mb_hp_show);
              // tot_base_hp += `${count},${base_hp}|`;

              return (
                <tr key={i}>
                  <td>{pageInfo.totalArticles - pageInfo.articlesPerPage * (pageInfo.currentPage - 1) - i}</td>
                  <td>
                    <input
                      type="checkbox"
                      className="checkbox"
                      id={`achk${count}`}
                      name={`chk[${count}]`}
                      value={base_seq}
                    />
                    <label htmlFor={`achk${count}`}><span></span></label>
                  </td>
                  <td
                    style={{cursor: "pointer"}}
                    onClick={() => {
                      history.push({
                        pathname: '/employee/reg', state: {
                          baseSeq: base_seq,
                        }
                      });
                    }}
                  >
                    {/*<a href={`emp_reg.html?base_seq=${base_seq}&page=${page}&${link_param}`}>*/}
                    <strong>{user_name}</strong>
                    {/*</a>*/}
                  </td>
                  <td>{position_name}</td>
                  <td>{pay_part_txt}</td>
                  <td>{part_name}</td>
                  <td>{new_position_name}</td>
                  <td>{pt_YN_txt}</td>
                  <td>
                    <div align="right" style={{paddingRight: '5px'}}>{Fn.numberWithCommas(pu_basic_price)}</div>
                  </td>
                  <td>
                    <div align="right" style={{paddingRight: '5px'}}>{Fn.numberWithCommas(pt_basic_price)}</div>
                  </td>
                  <td>
                    <div align="right" style={{paddingRight: '5px'}}>{Fn.numberWithCommas(pu_hour_price)}</div>
                  </td>
                  <td>
                    <div id={`default_show${count}`}>***-****-****</div>
                  </td>
                  <td>{in_date.substring(2, 10).replace(/-/g, ".")}</td>
                  <td>
                    <div align="left" style={{paddingLeft: '5px'}}>{groupware_id_show}</div>
                  </td>
                  <td>{inout_state_txt}</td>
                  <td>{contfile_name_show}</td>
                  <td>{infofile_name_show}</td>
                  <td>{accountfile_name_show}</td>
                  <td>{juminfile_name_show}</td>
                </tr>
              );
            })}
          </table>
        </div>
      </div>

      <nav className="p-3 mb-4 d-flex justify-content-between border-top flex-wrap">
        <Paging pageInfo={pageInfo} setCurrPage={page => setCurrPage(page)}/>
        <div>
          <div className="d-flex">
            <button type="button" className="btn btn-sm btn-outline-point mx-1" onClick={() => history.push("/employee/reg")}>추가</button>
            <button type="button" className="btn btn-sm btn-outline-dark mx-1" onClick={() => del_step()}>삭제</button>

            <button type="button" className="btn btn-sm btn-outline-point mx-1" onClick={() => {
              if (eval("pageInfo?.totalArticles") > 0) {
                if (!window.confirm(`검색된 ${pageInfo?.totalArticles}명 회원에게 SMS를 발송하시겠습니까?`)) return;
              } else {
                if (!window.confirm(`검색된 회원에게 SMS를 발송하시겠습니까?`)) return;
              }

              $('#SMS_editMsgid').val('');
              $('#SMS_b_type').val("manager");
              $('#SMS_s_type').val("all");

              setSmsModalOpen(true);
            }}>검색 SMS 발송
            </button>
            <button type="button" className="btn btn-sm btn-outline-point mx-1"
                    onClick={() => {
                      if ($('[id^=achk]:checked').length === 0) {
                        window.alert('체크된 리스트가 없습니다.');
                        return;
                      }

                      let con = $('[id^=achk]:checked').map(function () {
                        return $(this).val();
                      }).get().join("|");

                      $('#SMS_editMsgid').val(con);
                      $('#SMS_b_type').val("manager");
                      $('#SMS_s_type').val("sel");

                      setSmsModalOpen(true);
                    }}
            >선택 SMS 발송
            </button>

            <div className="d-flex mx-1">
              <ChkAuthNum type={"locker_info_change"}/>
            </div>
            <div className="d-flex mx-1">
              <input type="text" className="form-control" aria-describedby="button-addon2" placeholder="다운로드 사유 입력" style={{width: '140px'}} id="down_reason"/>
              {Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) >= 8 &&
                <button type="button" className="btn btn-sm btn-outline-point px-2" onClick={() => Excel_all_step()}>전스텝 엑셀저장</button>
              }
            </div>
            {pageInfo.totalArticles > 0 && (
              Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) === 9 ||
              (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) === 8 && localStorage.getItem("USER.systemManageYN") !== "Y" && pageInfo?.totalArticles <= 300) ||
              (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) === 7 && pageInfo?.totalArticles <= 300) ||
              (Fn.parseInt(localStorage.getItem("USER.systemUserAuth")) === 6 && pageInfo?.totalArticles <= 10)
            ) && (
              <button type="button" className="btn btn-sm btn-outline-dark px-2" onClick={() => Fn.showPhone('emp_list')}>연락처 확인</button>
            )}
          </div>
        </div>
      </nav>

      <input type="hidden" id="tot_base_hp" style={{display: "none"}}/>
      <input type="hidden" id="tot_record" style={{display: "none"}}/>
      <input type="hidden" id="tot_sql" style={{display: "none"}}/>

      <SmsNew
        isOpen={smsModalOpen}
        onModalClose={() => setSmsModalOpen(false)}
        searchType={"sms_list"}
        callback={() => {
          setSmsModalOpen(false);
        }}
      />
      <input type="hidden" id="SMS_b_type"/>
      <input type="hidden" id="SMS_s_type"/>
      <input type="hidden" id="SMS_editMsgid"/>

    </CmnCard>
  );
};

export default EmployeeList;
